<script lang="ts">
	import { onMount } from "svelte";
	import { makeComponentClassList } from "../utils";
	export let disabled = false;

	let hovering = false;
	let mousedown = false;
	let btn: HTMLButtonElement;

	onMount(() => {
		btn.addEventListener("mousedown", () => (mousedown = true));
		btn.addEventListener("mouseup", () => (mousedown = false));
		btn.addEventListener("mouseenter", () => (hovering = true));
		btn.addEventListener(
			"mouseleave",
			() => ((hovering = false), (mousedown = false))
		);
	});
	$: classVariables = makeComponentClassList($$props);

</script>

<button
	bind:this={btn}
	on:click|stopPropagation
	class={classVariables}
	on:touchend
	on:mousedown
	on:mouseup
	on:mouseenter
	on:mouseleave
	disabled={disabled}>
	<slot hovering={hovering} mousedown={mousedown} />
</button>

<style lang="scss">
	button {
		display: flex;
		padding: 0;
		outline: none;
		margin: none;
		background: none;
		border: none;

		&:hover {
			cursor: pointer;
		}
	}

</style>
